import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function GuaranteeSection() {
  return <section className="py-20 md:py-28 px-4 bg-warm-gray watermark-bg" data-id="element-150">
      <div className="max-w-3xl mx-auto text-center" data-id="element-151">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-lg border border-gold/20 relative overflow-hidden" data-id="element-152">
          <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-gold-light via-gold to-gold-light" data-id="element-153"></div>

          <div className="w-20 h-20 mx-auto bg-gold/10 rounded-full flex items-center justify-center mb-8" data-id="element-154">
            <ShieldCheck className="w-10 h-10 text-gold" data-id="element-155" />
          </div>

          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-156">
            Here's My Promise To You
          </h2>

          <p className="text-lg text-charcoal/80 leading-relaxed mb-6" data-id="element-157">
            If you download this guide, run the Pocket Card on your loudest
            relationship decision tonight, and you don't feel more clarity than
            you did before — just send me an email within 14 days and I'll
            refund every cent.
          </p>

          <p className="text-lg font-bold text-charcoal mb-8" data-id="element-158">
            No questions. No hoops. No guilt.
          </p>

          <p className="text-xl font-serif italic text-gold mb-10" data-id="element-159">
            I'm not asking you to trust me. I'm asking you to trust the
            framework for 5 minutes.
          </p>

          <div className="bg-cream p-6 rounded-xl mb-10 border border-warm-gray" data-id="element-160">
            <p className="font-serif italic text-charcoal/90 text-lg" data-id="element-161">
              "You already have what you need to take the next step. This guide
              just helps you hear it."
            </p>
          </div>

          <CTAButton mainText="GET YOUR COPY — $17.95" subText="14-Day Money-Back Guarantee | Instant Download | PDF Toolkit" large data-id="element-162" />
        </motion.div>
      </div>
    </section>;
}